<template>
  <div class="form" style="text-align:left;">
    <div class="title is-4">{{ title }}</div>


    <div class="columns">
      <div class="column" style="text-align:left;">
        <addonproduktionsverfahrenselect :selected="item.addonProductions"
                                         @input="setAddonProductions($event)"></addonproduktionsverfahrenselect>
      </div>
      <div class="column">

      </div>
    </div>


    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Name">
          <b-input maxlength="255" v-model="item.name"></b-input>
        </b-field>
      </div>
      <div class="column">

      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Gestaltungsleitfaden">
          <b-input size="is-small" readonly="true" v-model="item.gestaltungsleitfaden"></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Bild">
          <b-input maxlength="255" v-model="item.image"></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column is-half" style="text-align:left;">
        <label class="label">Beschreibung</label>
        <VueTrix maxlength="255" v-model="item.description" placeholder="Beschreibung einfügen"/>
      </div>
      <div class="column is-half">
        <b-field label="Code">
          <b-input maxlength="255" v-model="item.code"></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <label class="label">Verpackungen</label>
        <packageselect :selectedpackages="item.packages" @input="setPackages($event)"></packageselect>
      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Sortierung">
          <b-numberinput v-model="item.frontendorder"></b-numberinput>
        </b-field>
      </div>
      <div class="column"></div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:right;">
        <b-button type="is-primary" v-on:click="save()" :disabled="loading">Speichern</b-button>
      </div>
    </div>

  </div>
</template>


<script>
// @ is an alias to /src
import addonproduktionsverfahrenselect from "@/components/AddonProduktionsVerfahrenSelect.vue";
import packageselect from "@/components/PackageSelect.vue";
// import itemselect from "@/components/ItemSelect.vue";

import Vue from 'vue'
import VueTrix from "vue-trix";

const axios = require('axios');


export default {
  name: "home",
  components: {
    addonproduktionsverfahrenselect,
    packageselect,
    VueTrix,
    // itemselect
  },
  data() {
    return {
      title: "Neues Zusatzprodukt anlegen",
      item: {},
      loading: true,
      //  item: { 'id': 22, 'name': 'Beidseitig individuelles Kartenset', 'spielart': 'Kartenspiel', 'date': '2016-10-15 13:43:27' },
    }
  },
  watch: {},
  mounted: function () {
    console.log("FORM " + this.$route.params.id);
    if (this.$route.params.id) {
      this.title = "Zusatzprodukt bearbeiten";
      //Get-Game
      var _this = this;
      axios.get('/api/addons/' + this.$route.params.id, {
        withCredentials: true,
      })
          .then(function (response) {
            console.log(response.data);
            _this.item = response.data;
            _this.loading = false;

          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    } else {
      this.loading = false;
    }

  },
  methods: {
    setAddonProductions: function (val) {
      console.log("setAddonProductions");
      console.log(val);
      this.$set(this.item, "addonProductions", val)
    },
    setPackages: function (val) {
      console.log("setPackages");
      console.log(val);
      this.$set(this.item, "packages", val)
    },
    save: function () {
      if ((this.item.addonProductions) && (this.item.name) && (this.item.description) && (this.item.image) && (this.item.code) && (this.item.packages)) {

        //Set-Package
        var _this = this;
        var url = '/api/addons';


        console.log("SAVE");
        console.log(url);
        console.log(this.item);

        axios.post(url, this.item, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        })
            .then(function (response) {
              console.log(response.data);
              _this.$router.push({name: 'addonproducts'})
            })
            .catch(function (error) {
              console.log(error);
            })
            .then(function () {
              // always executed
            });

      } else {
        console.log("Alle Felder ausfüllen");
        this.$buefy.dialog.alert({
          title: 'Fehler',
          message: 'Bitte füllen Sie alle Felder aus. Mindestens ein Produktionsverfahren muss ausgefüllt sein.',
          type: 'is-danger',
          hasIcon: true,
          icon: 'alert-circle',
          iconPack: 'mdi'
        });

      }

    }
  }
};

</script>
